//@flow
import GlobalData from './globalData';

class ScriptLoader {

  loadScript(scriptId:string, urlKey:string, callback?:() => void) {
    if (global.inServer) return;
    this.addScript(scriptId, GlobalData.get('urls', urlKey), callback);
  }

  addScript(scriptId:string, src:?string, callback?:() => void) {
    if (global.inServer || document.getElementById(scriptId) || !src) return;

    const script:HTMLScriptElement = document.createElement('script');
    script.src = src;
    script.async = true;
    script.id = scriptId;
    if (callback) script.onload = callback;
    document && document.head && document.head.appendChild(script);
  }

  removeScript(scriptId:string) {
    const script = document.getElementById(scriptId);
    if (!script) return;
    document && document.head && document.head.removeChild(script);
  }
}

export default new ScriptLoader();
